var lightGallery;

(function ($) {

    //************************************
    // Parallax content two-half section
    //************************************

    $('.parallax-bottom').parallaxContent({
        shift: 15
    });

    $('.parallax-top').parallaxContent({
        shift: -15
    });

    function onload_page_scroll() {

        //var $header_height = $('.header').outerHeight();

        var doc_location = document.location.href;
        if (doc_location.indexOf("#") + 1) {
            var location_section = doc_location.split('#')[1];
            if (location_section != 'results') {
                $("html, body").animate({scrollTop: $("#" + location_section).offset().top - 280}, 700);
            }
        }
    }

    $(window).on('load', function () {
        onload_page_scroll();
    });

    $(document).ready(function () {

        if ($(".page-template-pagebuilder-services").length > 0) {
            $(".page-template-pagebuilder-services section:first").next().attr("id", "scroll");
        }

        // ****Blog Single Post Gallery ****//

        $(document).on('click', '.custom_btn_gallery_load_more', function (event) {
            $('div').removeClass('display_gallery_class_none');
            $(this).hide();
        });


        //************************************
        // Menu
        //************************************

        $('#menu-main-menu .menu-item a').addClass('menu-trigger');
        $('.menu-trigger').click(function () {
            $('#menu-trigger').toggleClass('clicked');
            $('.container-roll').toggleClass('push');
            $('.menu-type').toggleClass('open');
            $('body').toggleClass('overflow-hidden');
        });


        //************************************
        // MAIN NAV
        //************************************
        function initDropdownToggle() {
            var counter = 1, ww;

            ww = $(window).width();
            $(window).on('resize', function () {
                ww = $(window).width();
            });

            $('.navbar-nav > .menu-item-has-children').each(function () {
                var $this = $(this);
                var $sub_menu = $this.find('> .sub-menu');
                var dropdown_btn = $this;
                var dropdownToggle = $('<button/>', {
                    'type': 'button',
                    'class': 'collapse-toggle',
                    'value': 'dropdown',
                    'data-toggle': 'collapse',
                    'data-target': '#sub-collapse-' + counter
                });

                dropdownToggle.append('<i class="mobile-icon icon icon-down-dir"></i>');

                $this.find('> a').after(dropdownToggle);
                $sub_menu.attr('id', 'sub-collapse-' + counter++);
                $sub_menu.addClass('collapse');

                $sub_menu.on('show.bs.collapse', function () {
                    var $sub_menu_items = $(this).children('li');
                    $(this).find('.sub-menu.collapse').collapse('hide');
                    TweenMax.staggerTo($sub_menu_items, 0.1, { opacity: 1 }, 0.07);
                });

                $sub_menu.on('hide.bs.collapse', function () {
                    var $sub_menu_items = $(this).children('li');
                   // TweenMax.to($sub_menu_items, 0, { opacity: 0 });
                });

                dropdown_btn.hover(
                    function () {
                        if (ww > 1000) {
                            $('.header').addClass('open');
                            $this.addClass("open");

                            TweenMax.set($sub_menu, { height: "auto", autoAlpha: 1 });
                            TweenMax.from($sub_menu, 0.3, { autoAlpha: 0, height: 0 });
                        }
                    },
                    function () {
                        if (ww > 1000) {
                            $('.header').removeClass('open');
                            $this.removeClass("open");

                            TweenMax.to($sub_menu, 0.3, {
                                height: 0, autoAlpha: 0
                            });
                        }
                    }
                );

                // Handle second-level sub-menus
                $sub_menu.children('li').each(function () {
                    var $sub_item = $(this);
                    var $sub_sub_menu = $sub_item.find('> .sub-menu');

                    if ($sub_sub_menu.length) {
                        var $sub_sub_menu_items = $sub_sub_menu.children('li');
                        var subDropdownToggle = $('<button/>', {
                            'type': 'button',
                            'class': 'collapse-toggle-1',
                            'value': 'dropdown',
                            'data-toggle': 'collapse',
                            'data-target': '#sub-collapse-' + counter
                        });

                        subDropdownToggle.append('<i class="mobile-icon icon icon-down-dir"></i>');

                        $sub_item.find('> a').after(subDropdownToggle);
                        $sub_sub_menu.attr('id', 'sub-collapse-' + counter++);
                        $sub_sub_menu.addClass('collapse');

                        subDropdownToggle.on('click', function(e) {
                            e.stopPropagation();
                            $sub_sub_menu.collapse('toggle');
                        });

                        $sub_item.hover(
                            function () {
                                if (ww > 1000) {
                                    $sub_item.addClass("open");

                                    TweenMax.set($sub_sub_menu, { height: "auto", autoAlpha: 1 });
                                    TweenMax.from($sub_sub_menu, 0.3, { autoAlpha: 0, height: 0 });
                                }
                            },
                            function () {
                                if (ww > 1000) {
                                    $sub_item.removeClass("open");

                                    TweenMax.to($sub_sub_menu, 0.3, {
                                        height: 0, autoAlpha: 0
                                    });
                                }
                            }
                        );
                    }
                });
            });
        }

        initDropdownToggle();


        //************************************
        // anchor top banner arrow
        //************************************

        $(document).on('click', '.bottom-btn-row a', function (event) {
            event.preventDefault();

            var $header_height = $('.header').outerHeight();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - $header_height
            }, 700);
        });

        //************************************
        // anchor career page
        //************************************

        $(document).on('click', '.simple-content-type-3 .wrap-links a:nth-child(3)', function (event) {
            event.preventDefault();

            var $header_height = $('.header').outerHeight();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - $header_height
            }, 700);
        });

        //************************************
        // smooth scroll code
        //************************************

        $(document).on('click', '.hot-link', function (event) {
            event.preventDefault();

            let $header_height = $('.header').outerHeight();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - $header_height
            }, 700);
        });

        $(document).on('click', '.anchor-link-without-header', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 700);
        });

        //************************************
        // slider
        //************************************

        $('.top-banner-slider').slick({
            infinite: true,
            cssEase: 'linear',
            dots: true,
            arrows: false,
            fade: true,
            autoplay: false,
            autoplaySpeed: 4000
        });

        $('.quote-slider').slick({
            infinite: true,
            cssEase: 'linear',
            dots: false,
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 10000
        });

        $('.purposes-slider').slick({
            infinite: true,
            cssEase: 'linear',
            dots: false,
            arrows: false,
            fade: true,
            autoplay: false,
            autoplaySpeed: 6000
        });


        $('.building-slider').slick({
            infinite: true,
            cssEase: 'linear',
            dots: false,
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3000
        });

        $('.section-purposes-slider').slick({
            infinite: true,
            cssEase: 'linear',
            dots: false,
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3000
        });


        $('.employees-quote-slider').slick({
            infinite: true,
            cssEase: 'linear',
            dots: false,
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 10000
        });


        $('.slider-3d').slick({
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        adaptiveHeight: true,
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('.testimonials-slider').slick({
            infinite: true,
            cssEase: 'linear',
            dots: true,
            arrows: true,
            fade: false,
            autoplay: true,
            adaptiveHeight: false,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1101,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 761,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]

        });

        $('.slider-leadership-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: $('.slider-leadership-for, .slider-leadership-dots'),
            responsive: [
                {
                    breakpoint: 851,
                    settings: {
                        adaptiveHeight: true,
                    }
                }
            ]
        });

        $('.slider-leadership-dots').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: true,
            asNavFor: $('.slider-leadership-for, .slider-leadership-nav'),
        });

        $('.slider-leadership-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: $('.slider-leadership-for, .slider-leadership-dots'),
            centerMode: false,
            focusOnSelect: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1301,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 851,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 401,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        


        //************************************
        // Fixed header when scroll
        //************************************

        $(window).scroll(function () {
            if ($(window).scrollTop() >= 10) {
                $('header').addClass('fixed');
            }
            else $('header').removeClass('fixed');
        });




        //************************************
        // preloader
        //************************************
        $(window).load(function () {
            $('.preloader-wrap').fadeOut(1000);



        });

        // ==============================================================
        // ANIMATION TITLE BANNER
        // ==============================================================

        function is_on_screen_item_init() {

            var is_on_screen_item = $('.is_on_screen_item');

            if (is_on_screen_item.length > 0) {
                check_is_on_screen_item();
            }

            $(document).on('scroll load resize', function (event) {

                if (is_on_screen_item.length > 0) {
                    check_is_on_screen_item();
                }
            });


            function check_is_on_screen_item() {

                is_on_screen_item.each(function (i) {

                    var _ = $(this);

                    if (_.isOnScreen(0.4, 0.4)) {

                        _.addClass('is_on_screen');

                        // is_on_screen_item.splice(i, 1);
                    }

                });
            }
        }

        is_on_screen_item_init();

        $(window).on('resize', function () {
            is_on_screen_item_init();
        });

        // ==============================================================
        // Filter locations-positions
        // ==============================================================

        function filterCareers() {
            var filter = $('.all-locations-positions .buttons-wrap li.active .tab-btn').attr('data-filter');


            if ($(".employment_opportunities .content-item .filter-employment-btn.active").length) {

                var filter_cat = $('.employment_opportunities .content-item .filter-employment-btn.active').attr('data-filter');
                filter = filter + '.' + filter_cat;
            }
            $('.all-locations-positions .panel,.all-locations-positions .wpjb-job-list .wpjb-grid-row').hide();
            $('.all-locations-positions .panel.' + filter + ', .all-locations-positions .wpjb-job-list .wpjb-grid-row.' + filter).fadeIn('slow');
        }

        if ($('.all-locations-positions').length) {

            $('.all-locations-positions .buttons-wrap li .tab-btn').on('click', function (event) {
                event.preventDefault();

                if (!$(this).parent('li').hasClass('active')) {
                    $(this).closest('.buttons-wrap').find('li.active').removeClass('active');
                    $(this).parent('li').addClass('active');
                }

                filterCareers();
            });

            $('.employment_opportunities .content-item .filter-employment-btn').on('click', function (event) {
                event.preventDefault();

                $('.employment_opportunities .content-item .filter-employment-btn.active').removeClass('active');
                $(this).addClass('active');

                filterCareers();
            });


        }

        // ==============================================================
        // Animated brackets
        // ==============================================================

        $('.animated-brackets-type-1').animatedBrackets({
            points: [
                '100 80, 100 100, 0 100, 0 0, 100 0, 100 20'
            ],
            stroke_width: 5,
            color: 'rgba(255, 255, 255, 0.26)'
        });

        $('.animated-brackets-type-2').animatedBrackets({
            points: [
                '100 80, 100 100, 0 100, 0 0, 100 0, 100 20'
            ],
            stroke_width: 5,
            color: '#ebebeb'
        });

        $('.animated-brackets-type-3').animatedBrackets({
            points: [
                '0 20, 0 0, 100 0, 100 100, 0 100, 0 80'
            ],
            stroke_width: 5,
            color: '#f5f5f5'
        });

        $('.animated-brackets-type-4').animatedBrackets({
            points: [
                '100 80, 100 100, 0 100, 0 0, 100 0, 100 20'
            ],
            stroke_width: 4,
            color: '#ededed'
        });

        $('.animated-brackets-type-5').animatedBrackets({
            points: [
                '0 20, 0 0, 100 0, 100 20', '100 80, 100 100, 0 100, 0 80'
            ],
            stroke_width: 7,
            color: '#de9ba6'
        });

        $('.animated-brackets-type-6').animatedBrackets({
            points: [
                '0 20, 0 0, 100 0, 100 20', '100 80, 100 100, 0 100, 0 80'
            ],
            stroke_width: 9,
            color: '#2880de'
        });

        $('.animated-brackets-type-7').animatedBrackets({
            points: [
                '100 80, 100 100, 0 100, 0 0, 100 0, 100 20'
            ],
            stroke_width: 6,
            color: '#fafafa'
        });

        $('.animated-brackets-type-8').animatedBrackets({
            points: [
                '100 65, 100 100, 0 100, 0 0, 100 0, 100 35'
            ],
            stroke_width: 5,
            color: 'rgba(255, 255, 255, 0.26)'
        });

        $('.animated-brackets-type-9').animatedBrackets({
            points: [
                '0 20, 0 0, 100 0, 100 20', '100 80, 100 100, 0 100, 0 80'
            ],
            stroke_width: 5,
            color: 'hsla(0, 0%, 96%, 0.21)'
        });

        $('.animated-brackets-type-10').animatedBrackets({
            points: [
                '0 20, 0 0, 100 0, 100 20', '100 80, 100 100, 0 100, 0 80'
            ],
            stroke_width: 5,
            color: '#f5f5f5'
        });


        // ==============================================================
        // rotate words
        // ==============================================================


        if ($('.rotate-words').length) {

            $(function () {
                var $anchors = $('.rotate-words .word');

                (function _loop(idx) {
                    $anchors.removeClass('active').eq(idx).addClass('active');
                    setTimeout(function () {
                        _loop((idx + 1) % $anchors.length);
                    }, 2500);
                }(0));
            });

        }
    });


// ==============================================================
// 3d slider vue.js
// ==============================================================

    if ($('body').hasClass('page-id-7') || $('body').hasClass('page-id-382') || $('body').hasClass('page-id-682') || $('body').hasClass('page-id-100250') || $('body').hasClass('page-id-36777') || $('body').hasClass('page-id-140076')) {
        new Vue({
            el: '#slider_date',
            data: {
                slides: 0
            },
            components: {
                'carousel-3d': Carousel3d.Carousel3d,
                'slide': Carousel3d.Slide
            },

            mounted: function () {
                let self = this;

                self.slides = slider_about_data.slider_data;

            }
        });
    }


    // ==============================================================
// 3d slider vue.js careers page
// ==============================================================

    if ($('body').hasClass('page-id-15')) {
        new Vue({
            el: '#slider_gallery',
            data: {
                slides: 0
            },
            components: {
                'carousel-3d': Carousel3d.Carousel3d,
                'slide': Carousel3d.Slide
            },

            mounted: function () {
                let self = this;

                self.slides = slider_about_data_2.slider_data;

            }
        });
    }

    // ==============================================================
    // Gallery
    // ==============================================================

    $('.photo-slider').clipCarousel({
        thumbs_selector: '.photo-slider-thumb'
    });

    $('#slide-next').on('click', function () {
        $('.photo-slider').clipCarousel('go_to', 'forward');
    });

    $('#slide-prev').on('click', function () {
        $('.photo-slider').clipCarousel('go_to', 'backward');
    });

    $(".portfolio-slider").flipster({
        style: 'flat',
        spacing: -0.25,
        loop: true,
        buttons: true,
        scrollwheel: false
    });


    if ($('.project-categories').length) {

        var $grid = $('.portfolio-items .tab-pane');

        if ($('body').hasClass('home')) {
            $grid.isotope({
                itemSelector: '.item',
                filter: ':nth-child(-n+4)'
            });
        } else {
            $grid.isotope({
                itemSelector: '.item'
            });
        }


        $('.project-categories li span').click(function (e) {
            if ($(this).parent('li').hasClass('active')) {
                $(this).parent('li').removeClass('active');
                if ($('body').hasClass('home')) {
                    $grid.isotope({filter: ':nth-child(-n+4)'});
                } else {
                    $grid.isotope({filter: '*'});
                }

            } else {
                $('.project-categories li.active').removeClass('active');
                $(this).parent('li').addClass('active');
                var filter = $(this).attr('data-slug');
                if ($('body').hasClass('home')) {
                    $grid.isotope({filter: $('.' + filter + ':lt(4)')});
                } else {
                    $grid.isotope({filter: '.' + filter + ''});
                }
            }
        });

        /**** Get filter from query string to trigger isotope ****/
        if (!$('body').hasClass('home')) {
            var url = window.location.search;
            url = url.replace("?", '');

            var mycat = url.split("filter=").join("");

            $('.project-categories li').each(function (index, value) {
                // console.log($(this).find('span').attr('data-slug'));
                if ($(this).find('span').attr('data-slug') == mycat) {
                    $(this).find('span').trigger("click");
                }
            });
        }

    }

    // Blog list load more
    if ($('#archiveLoopWrapper').length) {
        var page = 2;
        $('#loadmoreanchor').click(function () {
            jQuery('#loadmoreanchor').html('Loading Entries..');
            var load_url = '?paged=' + page;
            jQuery('#archiveLoopWrapper').append(jQuery('<div class="page" id="p' + page + '">').load(load_url + ' .page > *', function () {
                page++;
                jQuery('#loadmoreanchor').html('Load More Entries +');
                if (jQuery('#WPTotalNumPages').html() < page) {
                    jQuery('.loadmoreanchor-wrap').css('display', 'none');
                }
            }));
        });
    }

    // ==============================================================
    // fix double tap in ios with animation on btn's
    // ==============================================================

    $(document).ready(function () {
        $(".btn-border-white, .btn-border-black").on("touchend", function (e) {
            var el = $(this);
            var link = el.attr("href");
            if (link !== undefined) {
                window.location = link;
            }
        });
    });

    $(document).ready(function () {
        $('.wpjb .wpjb-form .wpjb-element-input-label label.wpjb-label').each(function () {
            $(this).html($.parseHTML($(this).text()));
        });
    });

    $(window).on('load', function () {
        setTimeout(function () {
            $('.single-job .wpjb .wpjb-flash-info').fadeOut();
        }, 2000);


        jQuery('.callout-newsletter .employee-photo-slider').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 8000,
            pauseOnHover: true, 
            variableWidth: true,
            infinite: true,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });


    });



    //************************************
    // Youtube video
    //************************************
    $(document).ready(function () {
        $(".js-modal-btn").modalVideo();
    });

    //************************************
    // SLIDER ADWARDS YEARS (ONE & TWO)
    //************************************

    $('.awards-slider-one').slick({
        centerMode: true,
        dots: false,
        vertical: true,
        nextArrow: '<span class="arrow-next"></span>',
        prevArrow: '<span class="arrow-prev"></span>',
        focusOnSelect: true,
        slidesToShow: 5,
        asNavFor: '.awards-slider-two',
        centerPadding: 0,
        slidesToScroll: 1,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 1281,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    centerMode: true,
                    verticalSwiping: false,
                    slidesToScroll: 1,
                    dots: false
                }
            },
            {
                breakpoint: 880,
                settings: {
                    vertical: false,
                    slidesToShow: 1,
                    centerMode: true,
                    verticalSwiping: false,
                    slidesToScroll: 1,
                    dots: false
                }
            },
        ]
    });

    $('.awards-slider-two').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
        dots: false,
        fade: true,
        asNavFor: '.awards-slider-one',
        responsive: [
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            },
        ]
    });

    $('.careers-videos-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        variableWidth: false,
        dots: true,
        fade: true,
    });

    $('.careers-videos-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
       $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
    });

    $('.video-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        variableWidth: false,
        dots: true,
        fade: true,
    });

    $('.video-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
    });

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // Leadership page
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    
    var time = 0;
    var bioHeight = 0;
    var padding = 65;
    var width = $(window).width();


    //anim
    function Movement() {

        bioHeight = $('.teammate-item.active').find('.teammate-bio-wrap').height();

        if( width >= 1025 ) {
            $('.teammate-item').removeAttr('style');
            TweenLite.to('.team-wrap .teammates-row.active:not(:last-child)', .13, { paddingBottom: bioHeight + padding } );
            TweenLite.to('.team-wrap .teammates-row.active:last-child', .13, { paddingBottom: bioHeight} );
        } else if( width <= 1024 ) {
            $('.teammates-row').removeAttr('style');
            TweenLite.to('.teammate-item.active', .5, { paddingBottom: bioHeight + padding } );
        }
    }

    function Movement2() {

        bioHeight = $('.team-box-item.active').find('.teammate-bio-wrap').height();

        if( width >= 1025 ) {
            $('.team-box-item').removeAttr('style');
            TweenLite.to('.team-box-item.active', .13, { paddingBottom: bioHeight + padding } );
        } else if( width <= 1024 ) {
            $('.teammate-item').removeAttr('style');
            TweenLite.to('.team-box-item.active', .5, { paddingBottom: bioHeight + padding } );
        }
    }

    //reset
    function ResetPos() {

        $('.teammates-row').removeClass('active').removeAttr('style');
        $('.teammate-item').removeClass('active');
        $('.teammate-btn').removeClass('active');    
        $('.teammate-content').removeClass('active');   

        if( width <= 1024) {
            TweenLite.to('.teammate-item.close', .3, { paddingBottom: 0 } );
        }
    }

    function ResetPos2() {
        $('.team-box-item').removeClass('active');

        if( width <= 1024) {
            TweenLite.to('.team-box-item.close', .3, { paddingBottom: 0 } );
        }
    }

    //resize
    $(window).on('load resize', function () {

        width = $(window).width();

        if( width >= 1440 ) {
            padding = 95;    
        } else if( width <= 480 ) {
            padding = 40;
        } else {
            padding = 65;
        }

        if( $('.teammate-item').hasClass('active') ) {
            Movement();
        } else {
            bioHeight = 0;
        }

        if( $('.team-box-item').hasClass('active') ) {
            Movement2();
        } else {
            bioHeight = 0;
        }

    });

    //click on image
    $(".teammate-img").on('click', function() {

        var currentBth = $(this).parent().find('.teammate-btn');

        if( !currentBth.hasClass('active') ) {
            currentBth.click();
            currentBth.addClass('active');
        } else {
           currentBth.click();
           ResetPos();
           time = 0;

        }
        return false;
    });

    //
    $(".team-box-item a").on('click', function(e)  {
        e.preventDefault();
    });

    $(".team-box-item").on('click', function()  {
        width = $(window).width();

        //close previous bio
        $('.team-box-item.active').addClass('close');

        setTimeout(function() {
            $('.team-box-item.close').removeClass('close');
        }, 430);

        //open new bio
        if( !$(this).hasClass('active') ) {

            ResetPos2();

            $(this).addClass('active');

            function OpenBio() {

                Movement2();

                time = 400;
            }

            setTimeout(OpenBio, time);

        } else {
            ResetPos2();
            time = 0;
        }
    });

    //click event
    $(".teammate-btn").on('click', function() {
        console.log('111');

        width = $(window).width();

        //close previous bio
        $('.teammate-item.active').addClass('close');

        setTimeout(function() {
            $('.teammate-item.close').removeClass('close');
        }, 430);

        //open new bio
        if( !$(this).hasClass('active') ) {

            ResetPos();

            $(this).addClass('active');
            $(this).parent().parent().parent().addClass('active');
            $('.teammate-item.active').parent().addClass('active');

            function OpenBio() {

                Movement();

                $('.teammate-item.active .teammate-content').addClass('active');
                time = 400;
            }

            setTimeout(OpenBio, time);

        } else {
           ResetPos();
           time = 0;
        }

    });

    /////////////////
    $(window).ready( function () {
        setTimeout( function () {
            $(".smcx-widget").appendTo( $(".sm-iframe") );
        }, 1200 );
    });


    // Newsletter LP
    $(document).ready(function () {
        $(document).on('click', '.news-newsletter .tab-items a:not(.active)', function(e) {
            e.preventDefault();
            var tab = $(this).attr('data-target');
            $('.news-newsletter .tab-items a').removeClass('active');
            $(this).addClass('active');
            $('.news-newsletter .tab-content .tab-element.active').fadeOut('fast', function(){
                $(this).removeClass('active');
                $('.news-newsletter .tab-content .tab-element.tab-'+tab).fadeIn('fast', function(){
                    $(this).addClass('active');
                });
            });
        });
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/custom.es6